import React, { useContext } from "react";
import { TranslatorContext } from "../../context/Translator";

export default function LabelFieldComponent({ label, labelDir, fieldSize, option, type, placeholder,errorMessage='',showArrow=true,required, ...rest }) {
    const { t } = useContext(TranslatorContext)
    return (
        <div className={`mc-label-field-group ${ label ? labelDir || "label-col" : "" }`} style={{marginTop:'20px', marginBottom:'20px'}}> 
            {label && <label className="mc-label-field-title">{ t(label) } {required && <span style={{color:'red'}}>*</span>}</label>}
            {
                type ? 
                    <>
                        <input 
                            type = { type || "text" } 
                            placeholder = { placeholder || t('type_here') } 
                            className = {`mc-label-field-input ${ fieldSize || "w-md h-sm" }`} 
                            { ...rest } 
                            
                        />
                        {errorMessage !=='' && <span className="mc-label-field"  style={{ color:'red'}} >{t(errorMessage)}</span>}
                    </>
                :
                    <>
                    {
                        showArrow ?
                        <select style={{ backgroundImage: 'url(/images/dropdown.svg)' }} className={`mc-label-field-select ${ fieldSize || "w-md h-sm" }`} { ...rest }>
                            {option && option.map((item, index) => (
                                item.id?<option key={index} value={item.id}>{item.name}</option>:<option key={ index } value={ item }>{t(item)}</option>
                            ))}
                        </select> 
                        :
                        <select style={{}} className={`mc-label-field-select ${ fieldSize || "w-md h-sm" }`} { ...rest }>
                            {option && option.map((item, index) => (
                                item.id?<option key={index} value={item.id}>{item.name}</option>:<option key={ index } value={ item }>{t(item)}</option>
                            ))}
                        </select>
                    }
                    {errorMessage !=='' && <span className="mc-label-field" style={{ color:'red'}} >{t(errorMessage)}</span>}
                    </>
            }
        </div>
    )
}